

var TRUE = true,
FALSE = false,
PROTO = "prototype",
TYPE_UNDEF = "undefined",
NEG_ONE = -1,
NULL = null,
DOC_NODE_TYPE = 9,
EL_NODE_TYPE = 1,
LEN = "length",
DOC = "document",
DOC_EL = DOC + "Element",
CLASS_NAME = "className",
SCROLL_TO = "scrollTo",
BODY = "body",

BACK_COMPAT = "BackCompat",
SCROLL = "scroll",
OVER = "overflow",
PAR_NODE = "parentNode",
OFFSET = "offset",
OFF_PAR = OFFSET + "Parent",
OFF_TOP = OFFSET + "Top",
OFF_LEFT = OFFSET + "Left",
OFSW = OFFSET + "Width",
OFSH = OFFSET + "Height",
CLW = "clientWidth",
CLH = "clientHeight",
SCRW = SCROLL + "Width",
SCRH = SCROLL + "Height",
SCRT = SCROLL + "Top",
SCRL = SCROLL + "Left",

fitt = require("fitt"),
rtrue = fitt.rtrue,
rfalse = fitt.rfalse,
getWindow = fitt.getGlobal,
ParamHash = require('fitt-paramhash'),
FittURL = require('fitt-url'),
UA = require('fitt-ua'),
ieVer = UA && UA.ie || 0,
wbVer = UA && UA.webkit || 0,
geckVer = UA && UA.gecko || 0,
iosVer = UA && UA.ios || 0,

exp = {},

cstr = fitt.cstr,
strlc = fitt.strlc,
cnum = fitt.cnum,
rxp = fitt.regx,
rxSearch = fitt.regxSearch,
rxTest = fitt.test,
callSafe = fitt.callSafe,
operaVer = UA.opera,
nativeMax = Math.max;

/**
                       * Singleton class used for holding general HTML DOM manipulation. Uses shorter names,and provides small amount of cross-browser functionality and/or type safety.
                       * @name fitt.dom
                       * @namespace
                      */

/**
                          * Get the node type of a given node/HTML element.
                          * See <a href="https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType" target="_blank">MDN</a> for
                          * the list of values that a returned if the given 1st argument is truly a dom node of some type.
                          * If the 1st argument is not a valid node, or any other issue occurs, -1 is returned.
                          *
                          * @name fitt.dom.nodeType
                          * @function
                          * @static
                          * @param {HTMLElement|Node|Document|DocumentFragment} el
                          * @param {Boolean} [unsafe=false] If you know for sure the 1st argument is a node, passing true will force the function to not use a try / catch block which
                          *                                 slightly improves performance.
                          * @return {Number}
                         */

function nodeType(el)
{
  var n_type;

  try {
    n_type = cnum(el && el.nodeType, NEG_ONE);
  } catch (e) {
    n_type = NEG_ONE;
  }
  return n_type;
}

/**
   * Get a reference to an HTMLDocument, either the current document you are in, or if you pass
   * a dom reference in of some type the document for that given reference is returned (which may or may not be the same).
   * Returns null if no document is found, or if an invalid dom reference is passed in for the first argument.
   *
   * @name fitt.dom.doc
   * @function
   * @static
   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [el=null]
   * @return {HTMLDocument|null}
  */

function doc(el)
{
  var win = getWindow(),d = NULL,n_type;

  if (!arguments[LEN]) {
    d = win && win[DOC] || NULL;
  } else {
    n_type = nodeType(el);
    if (n_type === DOC_NODE_TYPE) {
      d = el;
    } else {
      try {
        d = el[DOC] || el.ownerDocument || NULL;
      } catch (e) {
        d = NULL;
      }
    }
  }
  return d;
}


/**
   * Get or set the current location of the page loaded in the web browser.
   * Function is assumed to be run in a browser (in fact all the functions in this
   * package are assuming that though they are save to run in other environments).
   * If no arguments are passed, it is assumed you just want to read the current
   * page URL and this function is essentially an alias for {@link fitt.URL.loc()}.
   *
   * If you pass any arguments it is assumed you want to set the location, a boolean
   * is returned to indicate the set was successful or not. It can fail if you
   * ran this function somewhere other than a browser or in scenarios where
   * security measures of the browser prevent you from setting the location.
   * Setting the location triggers an async navigation to occur.
   *
   * @name fitt.dom.loc
   * @function
   * @public
   * @param {String|fitt.URL} [newURL=''] A new URL to be set. If you pass any argument here it is assumed you want to reload the window/document with the given URL.
   *                                      If the URL passed in is invalid or empty, this will trigger a reload on the curent page.
   * @param {Boolean} [doReplace=false] Replace the current history entry with the given URL. Not relavent if the first argument is an invalid URL of some kind.
   * @return {fitt.URL|Boolean}
  */
function loc(newURL, doReplace) {

  var argCnt = arguments.length,
  doReload = FALSE,
  ret,win,loc;

  if (argCnt) {
    if (!newURL) {
      doReload = true;
    } else if (typeof newURL !== 'string') {
      if (newURL instanceof FittURL) {
        newURL = cstr(newURL);
        if (!newURL) {
          doReload = TRUE;
        }
      } else {
        newURL = cstr(newURL);
        newURL = new FittURL(newURL);
        newURL = cstr(newURL);
        if (!newURL) {
          doReload = TRUE;
        }
      }
    }
    win = getWindow();
    try {
      loc = win && win.location;
    } catch (e) {
      loc = NULL;
    }
    if (loc) {
      if (doReload) {
        loc.reload(TRUE);
      } else if (doReplace) {
        loc.replace(newURL);
      } else {
        loc.href = newURL;
      }
      ret = true;
    } else {
      ret = false;
    }
  } else {
    ret = FittURL.loc() || false;
  }

  return ret;
}


/**
  * Retrieve the host window object for a given HTML Element. Note that this is NOT the same as {@link fitt.dom.iframes.view}, which
  * returns the window reference INSIDE the IFRAME element.
  *
  * @name fitt.dom.view
  * @public
  * @function
  * @param {HTMLElement} [el=null] the HTML element for which you wish to find it's parent window, if not specified, or is falsy,
  *                                returns the main window in which this code is running.
  * @return {Document|null} null if nothing found
  *
  */

function view(el)
{
  var elWin = NULL,
  IE_WIN_PROP = "parentWindow",
  W3C_WIN_PROP = "defaultView",
  d;

  try {
    if (el) {
      elWin = el[IE_WIN_PROP] || el[W3C_WIN_PROP] || NULL;
      if (!elWin) {
        d = doc(el);
        elWin = d && (d[IE_WIN_PROP] || d[W3C_WIN_PROP]) || NULL;
      }
    } else {
      elWin = getWindow();
    }
  } catch (e) {
    elWin = NULL;
  }
  return elWin;
}

/**
   * Wrapper for document.getElementById, also allowing you to pass in a
   * reference node, window, document from which to get the element by
   * id in cases of reaching across frames / windows.
   *
   * @name fitt.dom.elt
   * @function
   * @static
   * @param {String} id The id of the element to search for
   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window to get the correct document to use
   * @return {HTMLElement|null}
  */

function elt(id, otherWin)
{
  var args = arguments,len = args[LEN],dc,ret = NULL;

  if (len > 1) {
    dc = doc(args[1]);
  } else {
    dc = doc();
  }
  try {
    ret = id && dc.getElementById(id) || NULL;
  } catch (e) {
    ret = NULL;
  }
  return ret;
}


/**
   * Wrapper for document.querySelectorAll/querySelector, also allowing you to pass in a
   * reference node, window, document from which to get the element by
   * id in cases of reaching across frames / windows.
   *
   * @name fitt.dom.qsa
   * @function
   * @static
   * @param {String} sel The CSS selector to use to find a given element
   * @param {Boolean} [firstOne=false] If true, return a NodeList for the given selector, rather than only the 1st item found.
   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window, document, or element to use a the parent for the call
   * @return {NodeList|HTMLElement|null}
  */

function qsa(sel, firstOne, otherWin)
{
  var args = arguments,len = args[LEN],dc,useNode,ret = NULL;

  if (len > 2) {
    useNode = args[2];
    if (isElement(useNode)) {
      dc = useNode;
    } else {
      dc = doc(useNode);
    }
  } else {
    dc = doc();
  }

  try {
    ret = sel && dc.querySelectorAll(sel) || NULL;
  } catch (e) {
    ret = NULL;
  }
  if (ret && firstOne && ret[LEN]) {
    ret = ret[0];
  }

  return ret;

}

/**
  * A wrapper around retrieving a list of tags by name.
  *
  * @name fitt.dom.tags
  * @public
  * @function
  * @param {String} name The name of the tags that you wish to look for, note that you can pass in "*" to find all.
  * @param {HTMLElement|Document} parNode (Optional) the parent node that you wish to look in, defaults to the current main document where this code runs.
  * @param {Boolean|String} [use_class_name=false] If boolean true is used, use the name argument as if it were a CSS class name rather than a tag name.
  *												  If a string is used, you can do a search on both tag name and CSS class name.
  * @return {HTMLElementCollection} List of tags found. Note that is NOT a real JavaScript Array
  *
  */

function tags(name, parNode, use_class_name)
{
  var ret = [],method = "getElementsByTagName",method_2 = "getElementsByClassName",
  tag_list,tag,tag_cnt,idx,match_ex = NULL;

  try {
    if (!parNode) parNode = doc();

    if (parNode) {
      if (use_class_name) {
        if (typeof use_class_name == "string") {
          if (parNode[method_2]) {
            tag_list = parNode[method_2](use_class_name);
            tag_cnt = tag_list && tag_list[LEN];
            idx = 0;
            if (tag_cnt) {
              /* eslint-disable no-cond-assign */
              while (tag = tag_list[idx++]) {
                if (tagName(tag) == name) {
                  ret.push(tag);
                }
              }
              /* eslint-enable no-cond-assign */
            }
          } else if (parNode[method]) {
            tag_list = parNode[method](name);
            tag_cnt = tag_list && tag_list[LEN];
            idx = 0;
            match_ex = name ? new rxp('(?:^|\\s+)' + use_class_name + '(?:\\s+|$)') : NULL;
            if (tag_cnt && match_ex) {
              /* eslint-disable no-cond-assign */
              while (tag = tag_list[idx++]) {
                if (rxSearch(match_ex, tag[CLASS_NAME]) != -1) {
                  ret.push(tag);
                }
              }
              /* eslint-enable no-cond-assign */
            }
          }
        } else {
          if (parNode[method_2]) {
            ret = parNode[method_2](name);
          } else if (parNode[method]) {
            tag_list = parNode[method]("*");
            tag_cnt = tag_list && tag_list[LEN];
            idx = 0;
            match_ex = name ? new rxp('(?:^|\\s+)' + name + '(?:\\s+|$)') : NULL;
            if (tag_cnt && match_ex) {
              /* eslint-disable no-cond-assign */
              while (tag = tag_list[idx++]) {
                if (rxSearch(match_ex, tag[CLASS_NAME]) != -1) {
                  ret.push(tag);
                }
              }
              /* eslint-enable no-cond-assign */
            }
          }
        }
      } else if (parNode[method]) {
        ret = parNode[method](name);
      }
    }
  } catch (e) {
    ret = [];
  }
  return ret;
}

/**
   * Return whether or not the given reference is an HTMLElement
   *
   * @name fitt.dom.isElement
   * @function
   * @public
   * @param {HTMLElement} el
   * @return {Boolean}
  */


function isElement(el) {return nodeType(el) === EL_NODE_TYPE;}

/**
                                                               * Retrieve/Set/Delete an element's attribute. Note that this handle's
                                                               * slight differences in the way HTML attributes are handled across browsers
                                                               * as well as being shorthand
                                                               *
                                                               * @name fitt.dom.attr
                                                               * @public
                                                               * @function
                                                               * @param {HTMLElement} el (Required) the HTML element to manipulate
                                                               * @param {String} attrName (Required) the attribute to set/get
                                                               * @param {String} [attrVal=void], if specified will set the value of the attribute for this element.  Passing null will remove the attribute completely
                                                               * @return {String} the value of the attribute normalized to a string (may be empty)
                                                               */

function attr(el, attrName, attrVal)
{
  var retVal = '';


  attrName = cstr(attrName);
  if (!attrName) return retVal;

  if (arguments[LEN] > 2) {
    try {
      if (attrVal === NULL) {
        el.removeAttribute(attrName);
      } else {
        attrVal = cstr(attrVal);
        if (strlc(attrName) == "class") {
          el[CLASS_NAME] = attrVal;
        } else {
          el.setAttribute(attrName, attrVal);
        }
      }
    } catch (e) {}
  }

  retVal = cstr(el.getAttribute(attrName));

  return retVal;
}

/**
  * A wrapper method for removing elements from a document rather than calling parentNode.removeChild raw.
  * Silences any errors that might occur.
  *
  * @name fitt.dom.purge
  * @public
  * @function
  * @param {HTMLElement} node The HTML element to be removed from the dom
  * @return {Boolean} Whether or not the element was successfully removed
  *
  */

function purge(node)
{
  var success = FALSE,parNode;

  try {
    parNode = par(node);
    if (parNode) {
      parNode.removeChild(node);
      success = TRUE;
    }
  } catch (e) {}

  node = parNode = NULL;
  return success;
}

/**
   * A wrapper for replacing elements from a document rather than calling [parentElement|parentNode].removeChild
   * raw, preventing unintended errors and returning true/false if successfull
   *
   * @name fitt.dom.swap
   * @function
   * @public
   * @param {HTMLElement} oldNode The node to be replaced / removed
   * @param {HTMLElement} [newNode=null] The replacement (can be null)
   * @return {Boolean}
  */

function swap(oldNode, newNode)
{
  var success = FALSE,parNode;
  try {
    parNode = par(oldNode);
    if (parNode) {
      parNode.replaceChild(newNode, oldNode);
      success = TRUE;
    }
  } catch (e) {}

  oldNode = newNode = parNode = NULL;
  return success;

}

/**
  * Append and HTMLElement to another HTMLElement
  *
  * @name fitt.dom.append
  * @public
  * @function
  * @param {HTMLElement} parNode (Required) the HTML element to manipulate
  * @param {HTMLElement} child (Required) the new HTML element to add to the parent
  * return {HTMLElement|null} the new reference to the child element that was appended, or null if failure
  *
  */

function append(parNode, child)
{
  var ret = NULL;
  try {
    ret = parNode.appendChild(child);
  } catch (e) {
    ret = NULL;
  }

  return ret;
}

/**
   * Retrive the parent element of an HTML element
   *
   * @name fitt.dom.par
   * @public
   * @function
   * @param {HTMLElement} el (Required) the HTML element to check
   * return {HTMLElement} the new reference to the parent element or null if there is an error or the element has no parent
   *
  */
function par(el)
{
  var ret = NULL;
  try {
    ret = el && (el.parentNode || el.parentElement) || NULL;
  } catch (e) {
    ret = NULL;
  }
  return ret;
}

/*
   * Detect if a given CSS selector can be used to find / match the given node
   *
   * @name fitt.dom.matches
   * @public
   * @function
   * @param {String} sel (Required) CSS selector string
   * @param {HTMLElement} tgt (Required) the node
   * @return {Boolean}
  */

function matches(sel, tgt) {

  var idx = 0,
  result = false,
  matchResults,matchResult;

  sel = cstr(sel);

  if (isElement(tgt) && sel) {
    matchResults = qsa(sel, false, view(tgt)) || [];
    while (matchResult = matchResults[idx++]) {
      if (matchResult === tgt) {
        result = true;
        break;
      }
    }
  }

  return result;
}


/**
   * Find an ancestor / parent node of the current node with a given
   * node/element name
   *
   * @name fitt.dom.closest
   * @public
   * @function
   * @param {HTMLElement} target (Required) the HTML element to check
   * @param {string} nodeName (Required) the name of the parent node to check
   * @param {Object} [opts=null] Additional options for the function
   * @param {String} [opts.strType='name'] The string passed as a 2nd argument is treated as a 'nodeName' by default. Pass 'css' to treat the string
   *                                       as a selector.
   * return {HTMLElement|Null} the new reference to the closest parent element that has nodeName if nothing found or invalid arguments passed in
   *
  */

function closest(target, nodeName, opts)
{
  var tgtPath = cstr(target && target.path),
  path = tgtPath || buildPath(target), // safari/firefox don't support path property
  i = 0,
  retNode = null,
  pathNode;

  if (!opts) opts = {};

  if (nodeName) {
    if (opts.strType === 'css') {
      if (!matches(nodeName, target)) {
        while (pathNode = path[++i]) {
          if (matches(nodeName, pathNode)) {
            retNode = pathNode;
            break;
          }
        }
      }
    } else {
      if (target && tagName(target, TRUE) !== nodeName) {
        while (pathNode = path[++i]) {
          if (tagName(pathNode, TRUE) === nodeName) {
            retNode = pathNode;
            break;
          }
        }
      }
    }
  }
  return retNode;
}

/**
   * Retrive a path to the given element from ancestor elements.
   * By default returns items in an ordered array, but can also be used
   * to return a string for XPath or CSS Selectors.
   *
   * @name fitt.dom.buildPath
   * @public
   * @function
   * @param {HTMLElement} elem (Required) the HTML element to check
   * @param {Object} [opts] Optional configuration for the function
   * @param {String} [opts.retType='node'] Valid values, 'node' or 'string'. Defaults to 'node' and returns an array of elements.
   *                                When set to string the path is returned as a string.
   * @param {String} [opts.strType='xpath']  Valid values, 'xpath', or 'css'. Defaults to 'xpath'
   * return {array} array of build path for the element
   *
  */
function buildPath(elem, opts) {

  var pathArray = [],
  output = pathArray,
  parNode;

  if (!opts) opts = {};

  if (isElement(elem)) {
    if (opts.retType === 'string') {
      pathArray.push(tagName(elem, TRUE));
      while (parNode = par(elem)) {
        if (!isElement(parNode)) break;

        pathArray.push(tagName(parNode, TRUE));
        elem = parNode;
      }

      pathArray = pathArray.reverse();

      if (opts.strType === 'css') {
        output = pathArray.join(' > ');
      } else {
        pathArray.unshift('');
        output = pathArray.join('/');
      }
    } else {
      pathArray.push(elem);

      while (parNode = par(elem)) {
        if (!isElement(parNode)) break;

        pathArray.push(parNode);
        elem = parNode;
      }
    }
  } else {
    if (opts.retType === 'string') {
      output = '';
    }
  }

  return output;
}

/**
  * Checks to see if an element is contained within another element
  *
  * @name fitt.dom.contains
  * @public
  * @function
  * @param {HTMLElement} element The HTML element in which you wish to search
  * @param {HTMLElement} needle The HTML element being looked for
  * @return {Boolean} True/false whether needle is within element
  *
  */

function contains(element, needle)
{
  var ret = FALSE,
  el_node_type = nodeType(element),
  needle_node_type = nodeType(needle),
  elDoc = doc(element),
  elDocEl = elDoc && elDoc[DOC_EL],
  elDocBody = elDoc && elDoc[BODY],
  CONTAINS = "contains",
  COMPARE_DOC_POS = "compareDocumentPosition";

  if (el_node_type == EL_NODE_TYPE && needle_node_type != NEG_ONE && elDoc && elDocEl && elDocBody) {
    if (element[CONTAINS]) {
      if (operaVer || needle_node_type == EL_NODE_TYPE) {
        try {
          ret = element[CONTAINS](needle);
        } catch (e) {
          ret = FALSE;
        }
      } else {
        while (needle)
        {
          if (element === needle) {
            ret = TRUE;
            break;
          }
          needle = par(needle);
          if (needle === elDocEl || needle === elDocBody) break;
        }
      }
    } else if (element[COMPARE_DOC_POS]) {
      try {
        ret = element === needle || !!(element[COMPARE_DOC_POS](needle) & 16);
      } catch (e) {
        ret = FALSE;
      }
    }
  }
  return ret;
}

/**
  * Check whether or not a given element is actually rendered in the document.
  *
  * @name fitt.dom.inDoc
  * @public
  * @function
  * @param {HTMLElement} el (Required) the HTML element to check
  * @param {Document} [doc=null] (Optional), the document to check within, if not passed in document associated with this class is used
  * @return {Boolean} true/false whether element is in given document
  *
  */

function inDoc(el, arg_doc)
{
  if (arguments[LEN] > 1) {
    arg_doc = doc(el);
  } else {
    arg_doc = doc();
  }
  return arg_doc && el && contains(arg_doc[DOC_EL], el);
}

/**
  * Retrieve the element associated as the root of a document
  * depending on the current mode of the page, returns either the document.documentElement
  * or document.body properties
  *
  * @name fitt.dom.docNode
  * @public
  * @function
  * @param {HTMLElement|HTMLWindow|HTMLDocument} el The element for which to look for the doc, if invalid, document where this class runs is assumed
  * @return {HTMLElement|null} The document root element or null if not found
  *
  */

function docNode(el)
{
  var d = el && doc(el) || doc(),
  compatMode = d && d.compatMode,
  root = d && d[DOC_EL] || NULL;

  if (compatMode && !operaVer && compatMode != 'CSS1Compat')
  root = d && d[BODY] || NULL;

  return root;
}

/**
  * Retrieve the head element associated of an HTML document
  *
  * @name fitt.dom.head
  * @public
  * @function
  * @param {HTMLElement|HTMLWindow|HTMLDocument} [el=null] An element, window, document, reference to use as an alternative to current global document object
  * @return {HTMLElement|null} The document head element or null if not found
  *
  */

function head(el)
{
  var d = el && doc(el) || doc(),
  hd = NULL;

  try {
    hd = d && d.head || tags('head', el)[0] || NULL;
  } catch (e) {
    hd = NULL;
  }

  return hd;
}

/**
   * Create an element
   *
   * @name fitt.dom.make
   * @public
   * @function
   * @param {String} [tagName='div'] The name of the tag to create.
   * @param {HTMLElement|Node|Document|DocumentFragment|Window} [otherWin=null] A DOM reference in another window to get the correct document to use
   * @return {HTMLElement} A new element
  */


function make(tname, pe)
{
  var d;

  tname = cstr(tname) || 'div';
  d = pe && doc(pe) || doc();

  return d.createElement(tname);
}

/**
   * A wrapper around retrieving the tagName of an HTML element (normalizes values to lower case strings).
   *
   * @name fitt.dom.tagName
   * @public
   * @function
   * @param {HTMLElement} el The HTML element for which to get the tag name.
   * @return {String} The tag name in all lower case of an HTML element, if it cannot be successfully retrieved, alwasys returns an empty string (which will evaluate to FALSE).
   *
  */

function tagName(el, isel)
{
  return (isel || isElement(el)) && strlc(el.tagName) || "";
}

/**
  * Get the inner text of an element.  If element is a script / style blockw with a "text" property, that is used,
  * otherwise innerText/textContent are used
  *
  * @name fitt.dom.txt
  * @public
  * @function
  * @param {HTMLElement} el The HTML element to read text content from
  * @return {String} The text content
  *
  */
function txt(el) {return el && (el.text || el.innerText || el.textContent) || "";}

/**
                                                                                   * Set/Get the CSS text of an HTML element, note that if you are just doing a get
                                                                                   * of a CSS value, this only reads from the style object of an element, and DOES not
                                                                                   * include style rules set from style sheets or inheritence.
                                                                                   *
                                                                                   * @name fitt.dom.css
                                                                                   * @public
                                                                                   * @function
                                                                                   * @param {HTMLElement} el (Required) the HTML element to manipulate
                                                                                   * @param {String|Object} val (Optional) the CSS string to set if specified (e.g. "background-color:transparent;position:absolute;top:0px;left:0px").
                                                                                   *                                       You may also specify an object with keys that are the css property names and their corresponding values.
                                                                                   *                                       Note that you must use CSS property names. For example {"background-color": "blue"}, rather than camel-case.
                                                                                   * @return {String} the value of the attribute normalized to a string (may be empty)
                                                                                   */

function css(el, val)
{
  var st;
  try {
    st = el.style;

    if (arguments[LEN] > 1) {
      if (typeof val === "object" && val) {
        if (!(val instanceof ParamHash)) {
          val = new ParamHash(val, ";", ":", TRUE, FALSE, TRUE);
          val = val.toString(";", ":", FALSE, TRUE);
        }
      } else {
        st.cssText = cstr(val);
      }
    } else {
      val = st.cssText;
    }
  } catch (e) {
    val = "";
  }
  return val;
}

/**
   * Get the current style object or an attribute
   * of the current style on an HTMLElement using W3C methods
   *
   * @name fitt.dom.currentStyle
   * @public
   * @function
   * @param {HTMLElement} el The element to get style info from
   * @param {String} [attr] The style attribute (in JS format of camel-case, not with dashes) to get a value of
   * @param {String} [psuedoClass]
   * @return {Object|String} The current style object or a string value of the style attribute. Returns empty string or NULL on failure.
  */

function currentStyle(el, attr, psuedoClass)
{
  var st,val = "";
  try {
    st = view(el).getComputedStyle(el, cstr(psuedoClass) || NULL);
  } catch (e) {
    st = NULL;
  }

  if (arguments[LEN] > 1 && attr && st) {
    try {
      val = st[attr];
    } catch (e) {
      val = "";
    }
  } else {
    val = st;
  }
  return val;
}

/**
   * Create a non-visible Image object used for pre-caching or firing HTTP beacons.
   * (Note that no validation of the src URI occurs).
   *
   * @name fitt.dom.img
   * @public
   * @function
   * @param {String} src The URI to set for the Image object
   * @return {Image} a new Image object
   *
  */

function img(src, f_onload, f_onerr)
{
  var o = new Image();

  function HANDLE_imgEvents()
  {
    callSafe(f_onload, o);
    callSafe(f_onerr, o);
    o.onload = o.onerror = NULL;
    f_onload = f_onerr = o = NULL;
  }
  o.onload =
  o.onerror = HANDLE_imgEvents;
  o.src = src;
  return o;
}


/**
   * Attach an event handler to an HTMLElement
   *
   * @name fitt.dom.attach
   * @public
   * @function
   * @param {HTMLElement} el the HTML element to attach an event handler too
   * @param {String} name  the name of the event to listen too
   * @param {Function} cb  the function used to handle the particular event
   *
  */

function attach(obj, name, cb, do_capture)
{
  var bOK = FALSE,call_inf = {};

  do_capture = do_capture || FALSE;

  callSafe(obj && obj.addEventListener, obj, call_inf, name, cb, do_capture);

  if (!call_inf.err) bOK = TRUE;

  obj = cb = NULL;
  return bOK;
}

/**
   * Detach an event handler to an HTMLElement
   *
   * @name fitt.dom.detach
   * @public
   * @function
   * @param {HTMLElement} el the HTML element to attach an event handler too
   * @param {String} name the name of the event to listen too
   * @param {Function} cb the function used to handle the particular event
   *
  */

function detach(obj, name, cb, do_capture)
{
  var bOK = FALSE,call_inf = {};

  do_capture = do_capture || FALSE;

  callSafe(obj && obj.removeEventListener, obj, call_inf, name, cb, do_capture);

  if (!call_inf.err) bOK = TRUE;

  obj = cb = NULL;
  return bOK;
}

/**
   *
   * Wrapper to get the target / src element of a given event object
   * that is passed to event handler functions in the dom.
   *
   * @name fitt.dom.evtTgt
   * @public
   * @function
   * @param {Event} evt The event object
   * @return {HTMLElement|Document|Window|null} target object for the event if available, otherwise null
  */

function evtTgt(evt)
{
  var tgt = NULL;

  try {
    tgt = evt && (evt.target || evt.srcElement) || NULL;
  } catch (e) {
    tgt = NULL;
  }

  return tgt;
}

/**
   * Calls DOM event supported cancellation methods, called
   * from {@link fitt.dom.evtCancel}.
   *
   * @name @fitt.dom-evtCanceller
   * @private
   * @function
   * @param {DOMEvent} evt The dom event to be cancelled
   *
  */
function evtCanceller() {}

evtCanceller = function () {
  var win = getWindow(),
  doc = win && win[DOC],
  evt_create = "createEvent",
  evt_type = "UIEvent",
  evtCancelMethods =
  {
    "preventDefault": 0,
    "stopImmediatePropagation": 0,
    "stopPropagation": 0,
    "preventBubble": 0 },

  prop,bufferFunc,helperFunc,evt;

  evt = callSafe(doc && doc[evt_create], doc, NULL, evt_type);
  evt = evt || callSafe(doc && doc[evt_create], doc, NULL, evt_type + 's');

  if (evt) {
    bufferFunc = ['function evtCanceller(evt) {\n'];

    for (prop in evtCancelMethods) {
      if (evt[prop]) {

        bufferFunc.push('try { evt.', prop, '(); } catch (e) {}\n');
      }
    }

    bufferFunc.push('return false; \n }\n return evtCanceller;');

    helperFunc = fitt.func(cstr(bufferFunc));
    return helperFunc();
  }
}() || evtCanceller;

/**
                      * Cancel DOM event all further bubbling / propagation and prevent the default
                      * actions
                      *
                      * @name fitt.dom.evtCancel
                      * @function
                      * @public
                      * @param {DOMEvent} evt The dom event object
                      * @param {Boolean} [retTrue=false] Whether to return true or false after cancellation. For most event handling function, returning true will act as a cancellation
                      *                                  but some handler function (namely onerror events) must return true.
                      * @return {Boolean}
                     */

function evtCancel(evt, retTrue) {

  if (evt) {
    /* old school ie, cancel event and bubble
               however we also use this for when event handling overrides
               take place so that we can cancel things */
    try {
      evt.returnValue = FALSE;
    } catch (e) {}
    try {
      evt.cancelBubble = TRUE;
    } catch (e) {}

    /*
                    * custom to denote cancellation occured
                   */
    try {
      evt.stopped = TRUE;
    } catch (e) {}

    /*
                    * function is generated at startup, checking the environment
                    * for supported known cancelation methods, and calls them all
                   */

    evtCanceller(evt);
  }

  return retTrue ? TRUE : FALSE;
}

/**
   * Simple Rectangle data structure class
   *
   * @name fitt.Rect2D
   * @public
   * @class
   * @param {Number} [t = 0]
   * @param {Number} [r = 0]
   * @param {Number} [b = 0]
   * @param {Number} [l = 0]
   * @property {Number} t  The top pixel coordinate
   * @property {Number} l  The left pixel coordinate
   * @property {Number} r  The right pixel coordinate
   * @property {Number} b  The bottom pixel coordinate
   * @property {Number} w  READ-ONLY gets the current width of the rectangle based on the r & l props
   * @property {Number} h  READ-ONLY gets the current height of the rectangle based on the b & t props
  */

function Rect2D(t, r, b, l)
{
  var me = this,
  args = arguments,
  argLen = args.length,
  argT = argLen >= 1 ? cnum(t, 0) : 0,
  argR = argLen >= 2 ? cnum(r, 0) : 0,
  argB = argLen >= 3 ? cnum(b, 0) : 0,
  argL = argLen >= 4 ? cnum(l, 0) : 0;

  me.t = argT;
  me.l = argL;
  me.r = argR;
  me.b = argB;
}

/**
   * Compute the width of the rectangle
   *
   * @name fitt.dom-Rect2D_getW
   * @private
   * @function
   * @return {Number}
  */

function Rect2D_getW()
{
  return this.r - this.l;
}

/**
   * Compute the height of the rectangle
   *
   * @name fitt.dom-Rect2D_getH
   * @private
   * @function
   * @return {Number}
  */

function Rect2D_getH()
{
  return this.b - this.t;
}

fitt.cprop(Rect2D[PROTO], 'w', NULL, TRUE, TRUE, FALSE, Rect2D_getW, NULL, TRUE);
fitt.cprop(Rect2D[PROTO], 'h', NULL, TRUE, TRUE, FALSE, Rect2D_getH, NULL, TRUE);

function DefaultDOMScrollInfo()
{
  var me = this;

  me[SCRL] =
  me[SCRT] =
  me[SCRW] =
  me[SCRH] = 0;
}

DefaultDOMScrollInfo = new DefaultDOMScrollInfo();

/**
                                                    * Simple constructor representing scroll information
                                                    *
                                                    * @name fitt.ScrollInfo
                                                    * @class
                                                    * @public
                                                    * @property {Number} x Horizontal scroll position
                                                    * @property {Number} y Vertical scroll position
                                                    * @property {Number} w Scroll width available
                                                    * @property {Number} h Scroll height available
                                                   */

function ScrollInfo()
{
  var me = this;

  me.x =
  me.y =
  me.w =
  me.h = 0;
}

/**
   * Checks of the string value passed in is CSS pixel format (suffix "px")
   *
   * @name fitt.dom-isPX
   * @private
   * @function
   * @param {String} val The string to check
   * @return {Boolean}
  */

function isPX(val)
{
  val = cstr(val);

  if (val && rxSearch(/\D+/g, val, TRUE, TRUE) == -1) return TRUE;
  if (val && rxSearch(/px/gi, val, TRUE, TRUE) != -1) return TRUE;
}

/**
   * Read border values of a given element, and adjust a rect object if necessary
   *
   * @name fitt.dom-calcBorders
   * @private
   * @function
   * @param {HTMLElement} el The element to look at
   * @param {Object} [r] The rectangle to adjust if passed in
   * @param {Object} [st] The current style object of an element
   * @return {Object} the original rect passed in with top and left position adjusted for borders, or a new rect at 0,0 with borders adjusted
  */

function calcBorders(el, r, st)
{
  var t = 0,l = 0,re = /^t(?:able|d|h|r|head|foot)$/i;

  st = st || currentStyle(el);
  if (st) {
    t = st.borderTopWidth;
    l = st.borderLeftWidth;
    t = isPX(t) ? cnum(t, 0) : 0;
    l = isPX(l) ? cnum(l, 0) : 0;

    if (geckVer && rxTest(re, tagName(el))) {
      t = l = 0;
    }
  }
  r = r || { t: 0, l: 0 };

  r.t += t;
  r.l += l;
  return r;
}


/**
   * Scroll the window to the given coordinates
   *
   * @name fitt.dom.scrollTo
   * @function
   * @param {Number} [x=0] The x coordinate with 0 being the farthest left. Number is normalized and defaulted to 0 if invalid.
   * @param {Number} [y=0] The y coordinate with 0 being the farthest top/up.  Number is normalized and defaulted to 0 if invalid.
   * @param {HTMLWindow} [argWin=null] The given window to scroll.
   * @return {Boolean} true/false if the action succeeded which will trigger an async scroll of the window. Note the window still
   *                              may not have actually scroll if it's alread at the given position, boolean just denotes success
   *                              of execution and a good environment (i.e. if you ran this in a NodeJS server it will return false).
  */

function scrollTo(x, y, argWin) {

  var ret = FALSE,win;

  try {
    if (argWin) {
      if (argWin[SCROLL_TO]) {
        win = argWin;
      } else {
        win = view(argWin);
      }
    } else {
      win = getWindow();
    }
  } catch (e) {
    win = NULL;
  }
  if (win) {
    x = cnum(x, 0, 0);
    y = cnum(y, 0, 0);
    try {
      win[SCROLL_TO](x, y);
      ret = TRUE;
    } catch (e) {
      ret = FALSE;
    }
  }
  return ret;
}

/**
   * Retrieve the current document scroll information
   *
   * @name fitt.dom.docScroll
   * @public
   * @function
   * @param {HTMLElement} [el=null] The element that resides in a given document to be checked, if not specified defaults to using the current document
   * @return {ScrollInfo} x, y, w, h properties relating to the document scroll position see {@link fitt.ScrollInfo}
  */

function docScroll(el)
{
  var pos = new ScrollInfo(),
  def = DefaultDOMScrollInfo,
  offsetX = 0,
  offsetY = 0,
  pre = "page",
  suf = "Offset",
  pgX = pre + "X" + suf,
  pgY = pre + "Y" + suf,
  usePageProps = FALSE,
  win = getWindow(),
  d,de,db,dv;

  if (el) {
    d = doc(el);
    if (d) {
      dv = view(el);
    } else {
      d = win[DOC];
      dv = win;
    }
  } else {
    d = win[DOC];
    dv = win;
  }
  de = d && d[DOC_EL] || def;
  db = d && d[BODY] || def;

  try {
    usePageProps = !!(dv && dv != top && pgX in dv);
  } catch (e) {
    usePageProps = FALSE;
  }

  if (usePageProps) {
    offsetX = cnum(dv[pgX], 0);
    offsetY = cnum(dv[pgY], 0);
  }

  pos.x = nativeMax(de[SCRL], db[SCRL], offsetX);
  pos.y = nativeMax(de[SCRT], db[SCRT], offsetY);
  pos.w = nativeMax(de[SCRW], db[SCRW], 0);
  pos.h = nativeMax(de[SCRH], db[SCRH], 0);
  return pos;
}

/**
   * Retrieve whether or not the given environment is a touch screen environment or not
   * note that we cache the information so if you use dev tools to change the environment
   * you have to refresh the browser window / restart the host process for updated information
   * to be returned
   *
   * @name fitt.dom.isTouch
   * @function
   * @return {Boolean}
  */

function isTouchDevice() {}

isTouchDevice = function () {

  var docObj = doc(),ret = rfalse,docEl;

  try {
    docEl = docObj && docObj[DOC_EL] || null;
    ret = docEl && 'ontouchstart' in docEl ? rtrue : rfalse;
  } catch (e) {
    ret = rfalse;
  }

  return ret;
}();

/**
      * Retrieve the rectangle info object for a given element including
      * width, height, top, left, right, bottom corners see {@link fitt.Rect2D}.
      *
      * @name fitt.dom.rect
      * @function
      * @param {HTMLElement} el  The element to get info on
      * @return {Rect2D}
     */

function rect(el)
{
  var r = new Rect2D(),
  BOUNDING = "getBoundingClientRect",
  scrollTop = 0,
  scrollLeft = 0,
  w = 0,
  h = 0,
  bCheck = FALSE,
  win = getWindow(),
  d = doc(el) || win && win[DOC] || {},
  compatMode = d.compatMode || '',
  docMode = d.documentMode || 0,
  root,scroll,parentNode,last_par,cur_st,par_cur_st,
  offX,offY,box,use_brute;

  if (isElement(el)) {
    try {
      cur_st = currentStyle(el);
      root = docNode(el);
      scroll = docScroll(el);
      r.l = el[OFF_LEFT] || 0;
      r.t = el[OFF_TOP] || 0;
      parentNode = el;
      last_par = NULL;
      bCheck = geckVer || wbVer > 519;
      use_brute = el === root;

      if (!use_brute) {
        if (ieVer > 0 && ieVer <= 9) {
          if (!docMode || docMode > 0 && docMode < 8 || compatMode === BACK_COMPAT) {
            offX = root.clientLeft;
            offY = root.clientTop;
          }
        }
        box = el[BOUNDING]();
        r.t = box.top;
        r.l = box.left;

        if (offX || offY) {
          r.l -= offX;
          r.t -= offY;
        }
        if (scroll.y || scroll.x) {
          if (!iosVer || iosVer >= 4.2) {
            r.l += scroll.x;
            r.t += scroll.y;
          }
        }
      } else {
        while (parentNode = parentNode[OFF_PAR])
        {
          if (!isElement(parentNode) || last_par === parentNode) break;

          offX = parentNode[OFF_LEFT];
          offY = parentNode[OFF_TOP];

          r.t += offY;
          r.l += offX;
          if (bCheck) r = calcBorders(parentNode, r);

          last_par = parentNode;
        }

        if (cur_st.position != "fixed") {
          parentNode = el;
          last_par = NULL;

          while (parentNode = parentNode[PAR_NODE])
          {
            if (!isElement(parentNode) || last_par === parentNode) break;
            if (parentNode == root) break;

            scrollTop = parentNode[SCRT];
            scrollLeft = parentNode[SCRL];

            if (geckVer) {
              //Firefox does something funky with borders when overflow is not visible.
              par_cur_st = currentStyle(parentNode);
              if (par_cur_st[OVER] != "visible") {
                r = calcBorders(parentNode, r, par_cur_st);
              }
            }
            if (scrollTop || scrollLeft) {
              r.l -= scrollLeft;
              r.t -= scrollTop;
            }
            last_par = parentNode;
          }

          r.l += scroll.x;
          r.t += scroll.y;
        } else {
          r.l += scroll.x;
          r.t += scroll.y;
        }
      }
      if (el == root) {
        h = el[CLH];
        w = el[CLW];
      } else {
        h = el[OFSH];
        w = el[OFSW];
      }

      r.b = r.t + h;
      r.r = r.l + w;
      r.w = nativeMax(w, 0);
      r.h = nativeMax(h, 0);
    } catch (e) {
      r = new Rect2D();
    }
  }
  return r;
}

/**
    * Get the window dimensions
    *
    * @name fitt.dom.winRect
    * @function
    * @public
    * @param {HTMLElement} [el] The element from which to grab the window to measure, if invalid assumed to be the window where this class runs.
    * @return {Object} t,l,b,r,w,h
    *
   */

function winRect(el)
{
  var ret = new Rect2D(),
  wi = el && view(el) || getWindow(),
  h = wi.innerHeight || 0,
  w = wi.innerWidth || 0,
  t = wi.screenY || wi.screenTop || 0,
  b = h + t,
  l = wi.screenX || wi.screenLeft || 0,
  r = w + l,
  root = docNode(el);

  if (!h && !w && root) {
    h = root[CLH] || 0;
    w = root[CLW] || 0;
    r = l + w;
    b = t + h;
  }

  ret.t = t;
  ret.l = l;
  ret.b = b;
  ret.r = r;

  return ret;
}

function callNativeRAF(f) {
  return requestAnimationFrame(f);
}

function callFakeRAF(f) {
  return setTimeout(f, 17); //60 FPS
}

/**
   * Simple requestAnimationFrame polyfill
   *
   * @name fitt.dom.rAF
   * @function
   * @public
   * @param {Function} f The function to be called
   *
  */

function rAF(cb) {}

rAF = typeof requestAnimationFrame == 'function' ? callNativeRAF : callFakeRAF;
exp =
{
  doc: doc,
  docNode: docNode,
  head: head,
  elt: elt,
  view: view,
  qsa: qsa,
  tags: tags,
  nodeType: nodeType,
  isElement: isElement,
  tagName: tagName,
  attr: attr,
  append: append,
  purge: purge,
  swap: swap,
  contains: contains,
  par: par,
  closest: closest,
  matches: matches,
  buildPath: buildPath,
  inDoc: inDoc,
  make: make,
  txt: txt,
  css: css,
  currentStyle: currentStyle,
  attach: attach,
  detach: detach,
  img: img,
  Rect2D: Rect2D,
  ScrollInfo: ScrollInfo,
  rect: rect,
  winRect: winRect,
  docScroll: docScroll,
  scrollTo: scrollTo,
  evtTgt: evtTgt,
  evtCancel: evtCancel,
  loc: loc,
  isTouch: isTouchDevice,
  rAF: rAF };



if (typeof module !== TYPE_UNDEF) {
  module.exports = exp;
}

if (fitt) {
  if (!fitt.Rect2D) fitt.Rect2D = Rect2D;
  if (!fitt.ScrollInfo) fitt.ScrollInfo = ScrollInfo;
  if (!fitt.dom) fitt.dom = exp;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-dom/fittDOM.js
// module id = 808
// module chunks = 0